import React from "react";
import { Route, IndexRedirect, IndexRoute, Redirect } from "react-router";

import App from "./components/app.jsx";
import Login from "./components/login.jsx";
import Activate from "./components/activate.jsx";
import AcceptCreatorInvite from "./components/accept-creator-invite.jsx";
import AcceptRevenueSharingInvite from "./components/accept-revenue-sharing-invite.jsx";
import Forgot from "./components/forgot.jsx";
import Reset from "./components/reset.jsx";
import Dashboard from "./components/dashboard.jsx";
import Welcome from "./components/welcome.jsx";
import Unauthorized from "./components/unauthorized.jsx";
import Account from "./components/account.jsx";
import RevenueSharing from "./components/revenue-sharing.jsx";
import SSO from "./components/sso.jsx";
import Organization from "./components/organization.jsx";
import Balance from "./components/balance.jsx";
import Billing from "./components/billing.jsx";
import ScannerSetup from "./components/scanner-setup.jsx";
import Feedback from "./components/feedback.jsx";
import Shop from "./components/shop.jsx";
import ApiSetup from "./components/api-setup.jsx";
import CreatorHub from "./components/creator-hub.jsx";
import CreatorFilm from "./components/creator-film.jsx";
import CreatorVirtualContent from "./components/creator-virtual-content.jsx";
import CreatorTitleDelivery from "./components/creator-title-delivery.jsx";
import EventBucket from "./components/event-bucket.jsx";
import NewEventBucket from "./components/new-event-bucket.jsx";
import EventBucketSettings from "./components/event-bucket-settings.jsx";
import EventBucketConfigurator from "./components/event-bucket-configurator.jsx";
import EventBucketEmbed from "./components/event-bucket-embed.jsx";
import EventBucketDuplicate from "./components/event-bucket-duplicate.jsx";
import EventBucketEverywhere from "./components/event-bucket-everywhere.jsx";
import Scheduler from "./components/scheduler.jsx";
import CheckIn from "./components/check-in.jsx";
import Balloting from "./components/balloting.jsx";
import BallotingSetup from "./components/balloting-setup.jsx";
import BallotingApp from "./components/balloting-app.jsx";
import BallotingPrint from "./components/balloting-print.jsx";
import BallotingRecord from "./components/balloting-record.jsx";
import BallotingTabulate from "./components/balloting-tabulate.jsx";
import BallotingConsolidatedAudit from "./components/balloting-consolidated-audit.jsx";
import Analytics from "./components/analytics.jsx";
import PassAnalytics from "./components/pass-analytics.jsx";
import AttendeeAnalytics from "./components/attendee-analytics.jsx";
import GeoAnalytics from "./components/geo-analytics.jsx";
import EventTicketAnalytics from "./components/event-ticket-analytics.jsx";
import EventSalesAnalytics from "./components/event-sales-analytics.jsx";
import EventPassesAnalytics from "./components/event-passes-analytics.jsx";
import StreamingAnalytics from "./components/streaming-analytics.jsx";
import SalesAnalytics from "./components/sales-analytics.jsx";
import LedgerAnalytics from "./components/ledger-analytics.jsx";
import RecurringPassAnalytics from "./components/recurring-pass-analytics.jsx";
import LedgerBoxOfficeReport from "./components/ledger-box-office-report.jsx";
import BoxOffice from "./components/box-office.jsx";
import Films from "./components/films.jsx";
import FilmEditor from "./components/film-editor.jsx";
import NewFilm from "./components/new-film.jsx";
import VirtualFestival from "./components/virtual-festival.jsx";
import VirtualFestivalLivestreamingHub from "./components/virtual-festival-livestreaming-hub.jsx";
import VirtualFestivalLivestreamingHubFilm from "./components/virtual-festival-livestreaming-hub-film.jsx";
import BulkImportFilms from "./components/bulk-import-films.jsx";
import Events from "./components/events.jsx";
import Event from "./components/event.jsx";
import EventEditor from "./components/event-editor.jsx";
import NewEvent from "./components/new-event.jsx";
import BulkImportEvents from "./components/bulk-import-events.jsx";
import PassBucket from "./components/pass-bucket.jsx";
import PassBucketEditor from "./components/pass-bucket-editor.jsx";
import NewPassBucket from "./components/new-pass-bucket.jsx";
import PassLabelPrinter from "./components/pass-label-printer.jsx";
import BulkImportPasses from "./components/bulk-import-passes.jsx";
import PassBuckets from "./components/pass-buckets.jsx";
import ItemBucket from "./components/item-bucket.jsx";
import ItemBucketEditor from "./components/item-bucket-editor.jsx";
import NewItemBucket from "./components/new-item-bucket.jsx";
import ItemBuckets from "./components/item-buckets.jsx";
import Coupons from "./components/coupons.jsx";
import Coupon from "./components/coupon.jsx";
import CouponEditor from "./components/coupon-editor.jsx";
import NewCoupon from "./components/new-coupon.jsx";
import Venues from "./components/venues.jsx";
import Venue from "./components/venue.jsx";
import VenueEditor from "./components/venue-editor.jsx";
import VenueSeatmapEditor from "./components/venue-seatmap-editor.jsx";
import NewVenue from "./components/new-venue.jsx";
import Tags from "./components/tags.jsx";
import TagEditor from "./components/tag-editor.jsx";
import NewTag from "./components/new-tag.jsx";
import Kiosks from "./components/kiosks.jsx";
import Kiosk from "./components/kiosk.jsx";
import NewKiosk from "./components/new-kiosk.jsx";
import Mailings from "./components/mailings.jsx";
import Mailing from "./components/mailing.jsx";
import MailingPreview from "./components/mailing-preview.jsx";
import NewMailing from "./components/new-mailing.jsx";
// import CloneMailing from "./components/clone-mailing.jsx";
import ExternalSyncs from "./components/external-syncs.jsx";
import ExternalSync from "./components/external-sync.jsx";
import NewExternalSync from "./components/new-external-sync.jsx";
import People from "./components/people.jsx";
import BulkImportPeople from "./components/bulk-import-people.jsx";
import Person from "./components/person.jsx";
import Orders from "./components/orders.jsx";
import Order from "./components/order.jsx";
import GiftCards from "./components/gift-cards.jsx";
import Reports from "./components/reports.jsx";
import ReportScheduler from "./components/report-scheduler.jsx";
import CrossEventBucketReports from "./components/cross-event-bucket-reports.jsx";
import Ticket from "./components/ticket.jsx";
import Pass from "./components/pass.jsx";
import PassHistory from "./components/pass-history.jsx";
import TicketHistory from "./components/ticket-history.jsx";
import AuditLog from "./components/audit-log.jsx";
import GodUsers from "./components/god-users.jsx";
import GodAutoCreateUserModal from "./components/god-auto-create-user-modal.jsx";
import GodRevenue from "./components/god-revenue.jsx";
import GodUpcomingEvents from "./components/god-upcoming-events.jsx";
import GodStreams from "./components/god-streams.jsx";
import GodLookup from "./components/god-lookup.jsx";
import GodInvoicingHub from "./components/god-invoicing-hub.jsx";
import GodOrganizationHealth from "./components/god-organization-health.jsx";
import CheckPass from "./components/check-pass.jsx";
import Tag from "./components/tag.jsx";

import UserStore from "./stores/UserStore.js";

function onDashboardEnter(nextState, replace) {
  // If not logged in, we'll catch them on the `App` componentWillMount
  if (!UserStore.getState().isLoggedIn) {
    return;
  }

  let missingPermissions = [],
    permitted = nextState.routes.every(r => {
      if (!r.permission) {
        return true;
      }
      let permissions = r.permission.split(/\s*,\s*/g);
      return permissions.some(p => {
        if (UserStore.hasPermission(p)) {
          return true;
        } else {
          missingPermissions.push(p);
          return false;
        }
      });
    });

  if (!permitted) {
    replace({
      pathname: "/unauthorized",
      state: {
        missing: missingPermissions
      }
    });
  }
}

function onDashboardChange(prevState, nextState, replace) {
  return onDashboardEnter(nextState, replace);
}

const AppRoutes = (
  <Route name="root" path="/" component={App}>
    <Route name="login" path="login" component={Login} />
    <Route name="activate" path="activate" component={Activate} />
    <Route name="forgot" path="forgot" component={Forgot} />
    <Route name="reset" path="reset" component={Reset} />
    <Route name="sso" path="sso" component={SSO} />
    <Route
      name="accept_creator_invite"
      path="accept_creator_invite"
      component={AcceptCreatorInvite}
    />
    <Route
      name="accept_revenue_sharing_invite"
      path="accept_revenue_sharing_invite"
      component={AcceptRevenueSharingInvite}
    />

    <Route
      name="dashboard"
      onEnter={onDashboardEnter}
      onChange={onDashboardChange}
      path=""
      component={Dashboard}
    >
      <Route name="welcome" path="welcome" component={Welcome} />
      <Route name="unauthorized" path="unauthorized" component={Unauthorized} />
      <Route name="account" path="account" component={Account} />
      <Route
        name="organization"
        permission="manage_organization"
        path="organization"
        component={Organization}
      />
      <Route
        name="billing"
        permission="manage_billing"
        path="billing"
        component={Billing}
      />
      <Route
        name="balance"
        permission="manage_balance"
        path="balance"
        component={Balance}
      />
      <Route
        name="revenue_sharing"
        path="revenue_sharing"
        component={RevenueSharing}
      />
      <Route
        name="revenue_sharing-event"
        path="revenue_sharing/:eventId(/:tab)"
        component={Event}
      />
      <Route
        name="scanner-setup"
        permission="manage_scanner,setup_scanner"
        path="account/scanner"
        component={ScannerSetup}
      />
      <Route name="feedback" path="feedback">
        <IndexRoute component={Feedback} />
        <Route path="*" component={Feedback} />
      </Route>
      <Route name="shop" path="shop">
        <IndexRoute component={Shop} />
        <Route path="*" component={Shop} />
      </Route>
      <Route
        name="api-setup"
        permission="manage_organization"
        path="organization/api"
        component={ApiSetup}
      />
      <Route name="creator-hub" path="creator_hub" component={CreatorHub} />
      <Route
        name="creator-film"
        path="creator_hub/films/:filmId"
        component={CreatorFilm}
      />
      <Route
        name="creator-virtual-content"
        path="creator_hub/virtual_content/:virtualContentId"
        component={CreatorVirtualContent}
      />
      <Redirect from="titles" to="creator_hub" exact />
      <Route
        name="creator-title-delivery"
        path="titles/:titleId/deliveries/:titleDeliveryId"
        component={CreatorTitleDelivery}
      />
      <Route
        name="new-event-bucket"
        permission="edit_event_bucket"
        path="event_buckets/new"
        component={NewEventBucket}
      />
      <Route
        name="event-bucket"
        permission="view_event_bucket,manage_configurator,manage_embed_wizard"
        path="event_buckets/:eventBucketId"
        component={EventBucket}
      />
      <Route
        name="event-bucket-settings"
        permission="edit_event_bucket,manage_configurator,manage_embed_wizard"
        path="event_buckets/:eventBucketId/settings"
        component={EventBucketSettings}
        ignoreScrollBehavior={true}
      >
        <Route
          name="event-bucket-configurator"
          permission="edit_event_bucket,manage_configurator"
          path="/event_buckets/:eventBucketId/settings/configurator(/:tab)"
          component={EventBucketConfigurator}
        />
        <Route
          name="event-bucket-embed"
          permission="edit_event_bucket,manage_embed_wizard"
          path="/event_buckets/:eventBucketId/settings/embed"
          component={EventBucketEmbed}
        />
        <Route
          name="event-bucket-duplicate"
          permission="edit_event_bucket"
          path="/event_buckets/:eventBucketId/settings/duplicate"
          component={EventBucketDuplicate}
        />
        <Route
          name="event-bucket-everywhere"
          permission="edit_event_bucket"
          path="/event_buckets/:eventBucketId/settings/everywhere"
          component={EventBucketEverywhere}
        />
      </Route>
      <Route
        name="bulk-import-events"
        permission="bulk_import_events"
        path="event_buckets/:eventBucketId/bulk_import_events"
        component={BulkImportEvents}
      />
      <Route
        name="balloting"
        permission="setup_balloting,app_balloting,print_balloting,record_balloting,tabulate_balloting,manage_balloting"
        path="event_buckets/:eventBucketId/balloting"
        component={Balloting}
      >
        <Route
          name="balloting-setup"
          permission="manage_balloting,setup_balloting"
          path="/event_buckets/:eventBucketId/balloting/setup"
          component={BallotingSetup}
        />
        <Route
          name="balloting-app"
          permission="manage_balloting,app_balloting"
          path="/event_buckets/:eventBucketId/balloting/app"
          component={BallotingApp}
        />
        <Route
          name="balloting-print"
          permission="manage_balloting,print_balloting"
          path="/event_buckets/:eventBucketId/balloting/print"
          component={BallotingPrint}
        />
        <Route
          name="balloting-record"
          permission="manage_balloting,record_balloting"
          path="/event_buckets/:eventBucketId/balloting/record"
          component={BallotingRecord}
        />
        <Route
          name="balloting-tabulate"
          permission="manage_balloting,tabulate_balloting"
          path="/event_buckets/:eventBucketId/balloting/tabulate"
          component={BallotingTabulate}
        />
        <Route
          name="balloting-consolidated-audit"
          permission="manage_balloting,tabulate_balloting"
          path="/event_buckets/:eventBucketId/balloting/consolidated_audit"
          component={BallotingConsolidatedAudit}
        />
      </Route>
      <Route
        name="analytics"
        permission="view_analytics_list"
        path="event_buckets/:eventBucketId/analytics"
        component={Analytics}
      />
      <Route
        name="pass-analytics"
        permission="view_analytics,view_pass_sales_analytics"
        path="event_buckets/:eventBucketId/analytics/passes"
        component={PassAnalytics}
      />
      <Route
        name="membership-analytics"
        permission="view_analytics,view_pass_sales_analytics"
        path="event_buckets/:eventBucketId/analytics/memberships"
        component={PassAnalytics}
      />
      <Route
        name="attendee-analytics"
        permission="view_analytics,view_attendee_analytics"
        path="event_buckets/:eventBucketId/analytics/attendees"
        component={AttendeeAnalytics}
      />
      <Route
        name="geo-analytics"
        permission="view_analytics,view_geo_analytics"
        path="event_buckets/:eventBucketId/analytics/geo"
        component={GeoAnalytics}
      />
      <Route
        name="event-ticket-analytics"
        permission="view_analytics,view_event_analytics"
        path="event_buckets/:eventBucketId/analytics/events"
        component={EventTicketAnalytics}
      />
      <Route
        name="event-sales-analytics"
        permission="view_analytics,view_standalone_ticket_analytics"
        path="event_buckets/:eventBucketId/analytics/event_sales"
        component={EventSalesAnalytics}
      />
      <Route
        name="event-passes-analytics"
        permission="view_analytics,view_pass_ticket_analytics"
        path="event_buckets/:eventBucketId/analytics/event_passes"
        component={EventPassesAnalytics}
      />
      <Route
        name="event-memberships-analytics"
        permission="view_analytics,view_pass_ticket_analytics"
        path="event_buckets/:eventBucketId/analytics/event_memberships"
        component={EventPassesAnalytics}
      />
      <Route
        name="streaming-analytics"
        permission="view_analytics,view_streaming_analytics"
        path="event_buckets/:eventBucketId/analytics/streaming"
        component={StreamingAnalytics}
      />
      <Route
        name="sales-analytics"
        permission="view_analytics,view_sales_analytics"
        path="event_buckets/:eventBucketId/analytics/sales"
        component={SalesAnalytics}
      />
      <Route
        name="recurring-pass-analytics"
        permission="view_analytics,view_recurring_pass_analytics"
        path="event_buckets/:eventBucketId/analytics/recurring_pass"
        component={RecurringPassAnalytics}
      />
      <Route
        name="recurring-membership-analytics"
        permission="view_analytics,view_recurring_pass_analytics"
        path="event_buckets/:eventBucketId/analytics/recurring_membership"
        component={RecurringPassAnalytics}
      />
      <Route
        name="ledger-analytics"
        permission="view_analytics"
        path="/analytics/ledger"
        component={LedgerAnalytics}
      />
      <Route
        name="ledger-box-office-report"
        permission="view_analytics"
        path="/analytics/box_office_report"
        component={LedgerBoxOfficeReport}
      />
      <Route
        name="box-office"
        permission="box_office"
        path="event_buckets/:eventBucketId/box_office"
        component={BoxOffice}
      />
      <Redirect
        from="event_buckets/:eventBucketId/box_office/passes"
        to="event_buckets/:eventBucketId/box_office"
      />
      <Redirect
        from="event_buckets/:eventBucketId/box_office/tickets"
        to="event_buckets/:eventBucketId/box_office"
      />
      <Route
        name="new-film"
        permission="manage_films,edit_film"
        path="event_buckets/:eventBucketId/films/new"
        component={NewFilm}
      />
      <Route
        name="film-editor"
        permission="manage_films,preview_virtual_screening,edit_film,view_film"
        path="event_buckets/:eventBucketId/films/:filmId/edit"
        component={FilmEditor}
      />
      <Redirect
        from="event_buckets/:eventBucketId/films/:filmId"
        to="/event_buckets/:eventBucketId/films/:filmId/edit"
      />
      <Route
        name="films"
        permission="manage_films,preview_virtual_screening,view_film_list"
        path="event_buckets/:eventBucketId/films"
        component={Films}
      />
      <Route
        name="bulk-import-films"
        permission="bulk_import_films"
        path="event_buckets/:eventBucketId/bulk_import_films"
        component={BulkImportFilms}
      />
      <Route
        name="scheduler"
        permission="edit_physical_event"
        path="event_buckets/:eventBucketId/scheduler"
        component={Scheduler}
      />
      <Route
        name="check-in"
        permission="box_office"
        path="event_buckets/:eventBucketId/check_in"
        component={CheckIn}
      />
      <Route
        name="pass-bucket-check-in"
        permission="box_office"
        path="event_buckets/:eventBucketId/pass_buckets/check_in"
        component={CheckIn}
      />
      <Route
        name="membership-check-in"
        permission="box_office"
        path="event_buckets/:eventBucketId/memberships/check_in"
        component={CheckIn}
      />
      <Route
        name="new-event"
        permission="edit_physical_event,edit_virtual_event"
        path="event_buckets/:eventBucketId/events/new"
        component={NewEvent}
      />
      <Route
        name="event-editor"
        permission="edit_physical_event,edit_virtual_event"
        path="event_buckets/:eventBucketId/events/:eventId/edit"
        component={EventEditor}
      />
      <Route
        name="event"
        permission="view_physical_event,view_virtual_event"
        path="event_buckets/:eventBucketId/events/:eventId(/:tab)"
        component={Event}
      />
      <Route
        name="events"
        permission="view_physical_event_list"
        path="event_buckets/:eventBucketId/events"
        component={Events}
      />
      <Route
        name="virtual-festival-event-editor"
        permission="manage_virtual_festival,edit_virtual_event"
        path="event_buckets/:eventBucketId/virtual_festival/events/:eventId/edit"
        component={EventEditor}
      />
      <Route
        name="virtual-festival-event"
        permission="manage_virtual_festival,preview_virtual_screening,view_virtual_event"
        path="event_buckets/:eventBucketId/virtual_festival/events/:eventId(/:tab)"
        component={Event}
      />
      <Route
        name="virtual-festival"
        permission="manage_virtual_festival,edit_virtual_event"
        path="event_buckets/:eventBucketId/virtual_festival/live"
        component={VirtualFestivalLivestreamingHub}
      />
      <Route
        name="virtual-festival"
        permission="manage_virtual_festival,edit_virtual_event"
        path="event_buckets/:eventBucketId/virtual_festival/live/:filmId"
        component={VirtualFestivalLivestreamingHubFilm}
      />
      <Route
        name="virtual-festival"
        permission="manage_virtual_festival,view_virtual_event_list"
        path="event_buckets/:eventBucketId/virtual_festival"
        component={VirtualFestival}
      />
      <Route
        name="virtual-festival-bulk-import-events"
        permission="manage_virtual_festival,bulk_import_events"
        path="event_buckets/:eventBucketId/virtual_festival/bulk_import_events"
        component={BulkImportEvents}
      />
      <Route
        name="new-pass-bucket"
        permission="edit_pass_bucket"
        path="event_buckets/:eventBucketId/pass_buckets/new"
        component={NewPassBucket}
      />
      <Route
        name="pass-bucket"
        permission="view_pass_bucket"
        path="event_buckets/:eventBucketId/pass_buckets/:passBucketId"
        component={PassBucket}
      />
      <Route
        name="pass-bucket-editor"
        permission="edit_pass_bucket,view_pass_bucket"
        path="event_buckets/:eventBucketId/pass_buckets/:passBucketId/edit(/:tab)"
        component={PassBucketEditor}
      />
      <Route
        name="pass-label-printer"
        permission="print_pass_labels"
        path="event_buckets/:eventBucketId/pass_label_printer"
        component={PassLabelPrinter}
      />
      <Route
        name="bulk-import-passes"
        permission="bulk_import_passes"
        path="event_buckets/:eventBucketId/bulk_import_passes"
        component={BulkImportPasses}
      />
      <Route
        name="pass-buckets"
        permission="view_pass_bucket_list"
        path="event_buckets/:eventBucketId/pass_buckets"
        component={PassBuckets}
      />
      <Route
        name="memberships"
        permission="view_pass_bucket_list"
        path="event_buckets/:eventBucketId/memberships"
        component={PassBuckets}
      />
      <Route
        name="new-membership"
        permission="edit_pass_bucket"
        path="event_buckets/:eventBucketId/memberships/new"
        component={NewPassBucket}
      />
      <Route
        name="membership"
        permission="view_pass_bucket"
        path="event_buckets/:eventBucketId/memberships/:passBucketId"
        component={PassBucket}
      />
      <Route
        name="membership-editor"
        permission="edit_pass_bucket,view_pass_bucket"
        path="event_buckets/:eventBucketId/memberships/:passBucketId/edit(/:tab)"
        component={PassBucketEditor}
      />
      <Route
        name="bulk-import-memberships"
        permission="bulk_import_passes"
        path="event_buckets/:eventBucketId/bulk_import_memberships"
        component={BulkImportPasses}
      />
      <Route
        name="membership-label-printer"
        permission="print_pass_labels"
        path="event_buckets/:eventBucketId/membership_label_printer"
        component={PassLabelPrinter}
      />
      <Route
        name="pass-history"
        permission="view_pass_bucket"
        path="event_buckets/:eventBucketId/passes/:passId/history"
        component={PassHistory}
      />
      <Route
        name="new-item-bucket"
        permission="edit_item_bucket"
        path="event_buckets/:eventBucketId/item_buckets/new"
        component={NewItemBucket}
      />
      <Route
        name="item-bucket"
        permission="view_item_bucket"
        path="event_buckets/:eventBucketId/item_buckets/:itemBucketId"
        component={ItemBucket}
      />
      <Route
        name="item-bucket-editor"
        permission="edit_item_bucket"
        path="event_buckets/:eventBucketId/item_buckets/:itemBucketId/edit"
        component={ItemBucketEditor}
      />
      <Route
        name="item-buckets"
        permission="view_item_bucket_list"
        path="event_buckets/:eventBucketId/item_buckets"
        component={ItemBuckets}
      />
      <Route
        name="new-coupon"
        permission="edit_coupon"
        path="event_buckets/:eventBucketId/coupons/new"
        component={NewCoupon}
      />
      <Route
        name="coupon"
        permission="edit_coupon,view_coupon"
        path="event_buckets/:eventBucketId/coupons/:couponId"
        component={Coupon}
      />
      <Route
        name="coupon-editor"
        permission="edit_coupon,view_coupon"
        path="event_buckets/:eventBucketId/coupons/:couponId/edit"
        component={CouponEditor}
      />
      <Route
        name="coupons"
        permission="view_coupon_list"
        path="event_buckets/:eventBucketId/coupons"
        component={Coupons}
      />
      <Route
        name="new-venue"
        permission="manage_venues"
        path="event_buckets/:eventBucketId/venues/new"
        component={NewVenue}
      />
      <Route
        name="venue"
        permission="manage_venues"
        path="event_buckets/:eventBucketId/venues/:venueId"
        component={Venue}
      />
      <Route
        name="venue-editor"
        permission="manage_venues"
        path="event_buckets/:eventBucketId/venues/:venueId/edit"
        component={VenueEditor}
      >
        <Route
          name="venue-seatmap-editor"
          permission="manage_venues"
          path="/event_buckets/:eventBucketId/venues/:venueId/edit/seatmap"
          component={VenueSeatmapEditor}
        />
      </Route>
      <Route
        name="venues"
        permission="manage_venues"
        path="event_buckets/:eventBucketId/venues"
        component={Venues}
      />
      <Route
        name="new-tag"
        permission="manage_tags"
        path="event_buckets/:eventBucketId/tags/new"
        component={NewTag}
      />
      <Route
        name="tag-editor"
        permission="manage_tags"
        path="event_buckets/:eventBucketId/tags/:tagId/edit"
        component={TagEditor}
      />
      <Route
        name="tag"
        permission="manage_tags"
        path="event_buckets/:eventBucketId/tags/:tagId"
        component={Tag}
      />
      <Route
        name="tags"
        permission="manage_tags"
        path="event_buckets/:eventBucketId/tags"
        component={Tags}
      />
      <Route
        name="new-kiosk"
        permission="manage_kiosks"
        path="event_buckets/:eventBucketId/kiosks/new"
        component={NewKiosk}
      />
      <Route
        name="kiosk"
        permission="manage_kiosks"
        path="event_buckets/:eventBucketId/kiosks/:kioskId"
        component={Kiosk}
      />
      <Route
        name="kiosks"
        permission="manage_kiosks"
        path="event_buckets/:eventBucketId/kiosks"
        component={Kiosks}
      />
      <Route
        name="new-mailing"
        permission="manage_mailings"
        path="event_buckets/:eventBucketId/mailings/new"
        component={NewMailing}
      />
      {/* <Route
        name="clone-mailing"
        permission="manage_mailings"
        path="event_buckets/:eventBucketId/mailings/clone/:mailingId"
        component={CloneMailing}
      /> */}
      <Route
        name="mailing"
        permission="manage_mailings"
        path="event_buckets/:eventBucketId/mailings/:mailingId"
        component={Mailing}
      />
      <Route
        name="mailing-preview"
        permission="manage_mailings"
        path="event_buckets/:eventBucketId/mailings/:mailingId/preview"
        component={MailingPreview}
      />
      <Route
        name="mailings"
        permission="manage_mailings"
        path="event_buckets/:eventBucketId/mailings"
        component={Mailings}
      />
      <Route
        name="new-external-sync"
        permission="manage_external_syncs"
        path="event_buckets/:eventBucketId/external_syncs/new"
        component={NewExternalSync}
      />
      <Route
        name="external-sync"
        permission="manage_external_syncs"
        path="event_buckets/:eventBucketId/external_syncs/:externalSyncId"
        component={ExternalSync}
      />
      <Route
        name="external-syncs"
        permission="manage_external_syncs"
        path="event_buckets/:eventBucketId/external_syncs"
        component={ExternalSyncs}
      />
      <Route
        name="event-bucket-people"
        permission="manage_people,view_people"
        path="event_buckets/:eventBucketId/people"
        component={People}
      />
      <Route
        name="people"
        permission="manage_people,view_people"
        path="people"
        component={People}
      />
      <Route
        name="person"
        permission="manage_people,view_people"
        path="people/:personId"
        component={Person}
      />
      <Route
        name="event-bucket-person"
        permission="manage_people,view_people"
        path="event_buckets/:eventBucketId/people/:personId"
        component={Person}
      />
      <Route
        name="bulk-import-people"
        permission="bulk_import_people"
        path="/bulk_import_people"
        component={BulkImportPeople}
      />
      <Route
        name="event-bucket-orders"
        permission="manage_orders,view_orders"
        path="event_buckets/:eventBucketId/orders"
        component={Orders}
      />
      <Route
        name="orders"
        permission="manage_orders,view_orders"
        path="orders"
        component={Orders}
      />
      <Route
        name="order"
        permission="manage_orders,view_orders,view_order"
        path="orders/:orderId"
        component={Order}
      />
      <Route
        name="event-bucket-order"
        permission="manage_orders,view_orders,view_order"
        path="event_buckets/:eventBucketId/orders/:orderId"
        component={Order}
      />
      <Route
        name="gift-cards"
        permission="manage_gift_cards"
        path="gift_cards"
        component={GiftCards}
      />
      <Route
        name="reports"
        permission="view_analytics"
        path="reports"
        component={Reports}
      />
      <Route
        name="scheduled-reports"
        permission="view_analytics"
        path="scheduled_reports"
        component={ReportScheduler}
      />
      <Route
        name="cross-event-bucket-reports"
        permission="view_analytics"
        path="reports/cross_event_bucket"
        component={CrossEventBucketReports}
      />
      {/* God only */}
      <Route
        name="audit-log"
        permission="manage_organization"
        path="/audit_log"
        component={AuditLog}
      />
      <Route
        name="god-users"
        permission="god"
        path="/god"
        component={GodUsers}
      />
      <Route
        name="god-auto-create"
        permission="god"
        path="/god/auto_create"
        component={GodAutoCreateUserModal}
      />
      <Route
        name="god-orders"
        permission="god"
        path="/god_orders"
        component={Orders}
      />
      <Route
        name="god-streams"
        permission="god"
        path="/god/streams"
        component={GodStreams}
      />
      <Route
        name="god-lookup"
        permission="god"
        path="/god/lookup"
        component={GodLookup}
      />
      <Route
        name="god-invoicing-hub"
        permission="god"
        path="/god/invoicing_hub"
        component={GodInvoicingHub}
      />
      <Route
        name="god-revenue"
        permission="god"
        path="/god/revenue"
        component={GodRevenue}
      />
      <Route
        name="god-upcoming-events"
        permission="god"
        path="/god/upcoming_events"
        component={GodUpcomingEvents}
      />
      <Route
        name="god-orgnaization-health"
        permission="god"
        path="/organization_health"
        component={GodOrganizationHealth}
      />
      {/* Lightweight redirect components */}
      <Route name="ticket" path="tickets/:ticketId" component={Ticket} />
      <Route
        name="event-bucket-ticket"
        path="event_buckets/:eventBucketId/tickets/:ticketId"
        component={Ticket}
      />
      <Route
        name="ticket-history"
        permission="view_pass_bucket"
        path="event_buckets/:eventBucketId/tickets/:ticketId/history"
        component={TicketHistory}
      />
      <Route name="pass" path="passes/:passId" component={Pass} />
      <Route
        name="event-bucket-pass"
        path="event_buckets/:eventBucketId/passes/:passId"
        component={Pass}
      />
      <Route name="check-pass" path="check_pass" component={CheckPass} />

      {/* Used as an intermediate screen during god account switcher to force page rebuild */}
      <Route name="blank" path="blank" component={() => <div />} />

      <Redirect from="*" to="/welcome" />
    </Route>
  </Route>
);

export default AppRoutes;



// WEBPACK FOOTER //
// ./src/app/app-routes.jsx